import type { ProductConfig } from '#types/config/components/product'

export default 'https://images.timberland.com/is/image/timberland/timberlandtreelogo' satisfies ProductConfig['defaultImageUrl']
